/*
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the MIT license.
*/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define(["require", "exports", "azure-devops-ui/List", "react", "../../Contracts/KubeServiceBase", "../../Resources", "../Common/KubeFilterBar"], function (require, exports, List_1, React, KubeServiceBase_1, Resources, KubeFilterBar_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var WorkloadsFilterBar = /** @class */ (function (_super) {
        __extends(WorkloadsFilterBar, _super);
        function WorkloadsFilterBar() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this._selection = new List_1.ListSelection(true);
            return _this;
        }
        WorkloadsFilterBar.prototype.render = function () {
            var items = [
                { id: KubeServiceBase_1.KubeResourceType.Deployments.toString(), text: Resources.DeploymentsDetailsText },
                { id: KubeServiceBase_1.KubeResourceType.ReplicaSets.toString(), text: Resources.ReplicaSetText },
                { id: KubeServiceBase_1.KubeResourceType.DaemonSets.toString(), text: Resources.DaemonSetText },
                { id: KubeServiceBase_1.KubeResourceType.StatefulSets.toString(), text: Resources.StatefulSetText }
            ];
            return (React.createElement(KubeFilterBar_1.KubeFilterBar, { filter: this.props.filter, keywordPlaceHolder: Resources.WorkloadText.toLocaleLowerCase(), pickListPlaceHolder: Resources.KindText, listItems: items, filterToggled: this.props.filterToggled, className: this.props.className || "", addBottomPadding: true, selection: this._selection }));
        };
        return WorkloadsFilterBar;
    }(React.Component));
    exports.WorkloadsFilterBar = WorkloadsFilterBar;
});
